<template>
  <div id='myApp' class='gPageBorder' v-loading='loading'>

    <el-dialog  :title="dialogConfig.tip" :visible.sync="dialogTopMgVisible" style='text-align:center' size=tiny>
      <el-button style='width:20%;' @click='processRecommend(0)'>{{$t('app_no')}}</el-button>
      <el-button type='primary' style='margin-left:20%;width:20%;' @click='processRecommend(1)'>{{$t('app_yes')}}</el-button>
    </el-dialog>

    <el-row>
      <el-col :span='20'>
        <el-button class='gSgLeftBtn'  type="success" @click="addVideo">{{$t('app_adddfvdeoad')}}</el-button>
        <el-button @click='allUndercarriage' type='danger'>{{$t('app_mulDel')}}</el-button>
        
      </el-col>

      <!-- <el-col :span='8'>
        <div style='width:100%;height:10px;'></div>
      </el-col> -->

      <!-- <el-col :span='4' >
        <div class='gCtrl'><el-select  v-model="appType" clearable :placeholder="$t('app_type')" @change='selectChange'>
          <el-option
            v-for="item in appTypes"
            :key="item.appClassifyId"
            :label="item.appClassifyName"
            :value="item.appClassifyId">
          </el-option>
        </el-select></div>
      </el-col> -->

      <el-col :span='4'>
        <div class='gSideCtrl'><el-input  :placeholder="$t('app_adname')" icon='search' :on-icon-click='query' @keyup.enter.native='query' v-model='queryKey'></el-input></div>
      </el-col>
    </el-row>
    

  
    <div >
      <el-table
      class='tbPoint gTopMg'
      @row-click='cellClick'
	    ref="multipleTable"
	    :data="tableData"
	    border
	    tooltip-effect="dark"
	    style="width: 100%;"
	    @selection-change="handleSelectionChange">
  	    <el-table-column
          align=center
  	      type="selection"
  	      width="55">
  	    </el-table-column>
  	    <el-table-column
          align=center
  	      prop='videoname'
  	      :label="$t('app_ad') + $t('app_name')"
  	      width="">
  	    </el-table-column>
  	   <el-table-column
          align='center'
  	      prop="duration"
  	      :label="$t('app_addur')"
  	      width="100">
  	    </el-table-column>

        <el-table-column
          align='center'
  	      prop="size"
  	      :label="$t('app_fileSize')"
  	      width="100">
  	    </el-table-column>

        <el-table-column
          align='center'
  	      prop="dimension"
  	      :label="$t('app_vsize')"
  	      width="100">
  	    </el-table-column>

        <el-table-column
          align='center'
  	      prop="username"
  	      :label="$t('app_addps')"
  	      width="100">
  	    </el-table-column>
  	    <!-- <el-table-column
          align=center
  	      prop="appInstallType"
  	      :label="$t('app_pltimes')"
  	      width='150'>
          <template slot-scope='scope'>
            <el-label>{{setInstallType(scope.row.appInstallType)}}</el-label>
          </template>
  	    </el-table-column> -->
       <!-- <el-table-column
          align=center
  	      prop="appInstallType"
  	      :label="$t('app_pldur')"
  	      width='100'>
          <template slot-scope='scope'>
            <el-label>{{setInstallType(scope.row.appInstallType)}}</el-label>
          </template>
  	    </el-table-column> -->
        
        
  	    <el-table-column
          align=center
  	      prop="createtime"
          :formatter="dateFormat"
  	      :label="$t('app_addtime')"
  	      width='200'>
          <!-- <template slot-scope='scope'>
            <label>{{timeLimit(scope.row)}}</label>
          </template> -->
  	    </el-table-column>

  	    
  	    <el-table-column
  	      prop="operate"
          align=center
  	      :label="$t('app_operate')"
  	      width='122'>
  	      <template slot-scope='scope'>
  	        <!-- <el-button v-show="scope.row.status === '2'" type=text @click='pushApp(scope.row)'>{{$t('app_push')}}</el-button> -->
            <!-- <el-tooltip class="item" effect="dark" :content="$t('app_push')" placement="top">
              <el-button v-show="scope.row.status === 2" type=text @click='pushApp(scope.row)'><i class="fa fa-upload" style=""></i></el-button>
            </el-tooltip> -->

            

            <!-- <el-button v-show="(scope.row.status !== '1' && scope.row.status !== '2') && scope.row.isoperate === 0" type=text @click='editApp(scope.row)'>{{$t('app_edit')}}</el-button> -->
            <!-- <el-tooltip class="item" effect="dark" :content="$t('app_edit')" placement="top">
              <el-button v-show="(scope.row.status !== 1 && scope.row.status !== 2)" type=text @click='editVideo(scope.row)'><i class="fa fa-pencil-square" style=""></i></el-button>
            </el-tooltip> -->

            <!-- <el-button v-show="scope.row.status !== '1' && scope.row.status !== '2' && scope.row.isoperate === 0" @click='submitApp(scope.row)' type='text'>{{$t('app_smVerify')}}</el-button> -->
            <!-- <el-tooltip class="item" effect="dark" :content="$t('app_smVerify')" placement="top">
              <el-button v-show="scope.row.status !== 1 && scope.row.status !== 2" @click='submitVideo(scope.row)' type='text'><i class="fa fa-external-link-square" style=""></i></el-button>
            </el-tooltip> -->

            <!-- <el-button v-show='scope.row.isoperate === 0' type=text @click='deleteApp(scope.row)'>{{$t('app_del')}}</el-button> -->
            <el-tooltip class="item" effect="dark" :content="$t('app_del')" placement="top">
              <el-button type='text'v-show='true' @click='deleteVideo(scope.row)'><i class="fa fa-trash-o" style="color:#FF4949"></i></el-button>
            </el-tooltip>

  	      </template>
  	    </el-table-column>
  	  </el-table>
    </div>
    
    <div class="gPgDiv" >

      <el-pagination
        class='gPg'
        @current-change="pageSelect"
        @size-change="pageSized"
        :current-page="index"
        :page-sizes='$gRows'
        :page-size="row"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
        </el-pagination>
    </div>
  </div>
</template>

<style>
  html body{background:white;margin:0;padding:0}
  #myApp{background:none;overflow:hidden;}

    #maAdd{overflow:hidden;margin-top:20px;}
    #maAdd button{}

    #maTable{margin-top:20px;margin-left:0px;margin-right:0px;}

    #maPage{overflow:hidden;background:none;margin-top:10px;}
      #maPage div{float:right;margin-right:0px;}

    
</style>

<script>
  import mm from 'moment'
  // import addApp from '@/components/app/my/AddApp'
  // import lang from '@/components/language/app'
  export default{
    data () {
      return {
        usrType: localStorage.userType,
        sNum: 0,
        mechanismId: window.localStorage['mechanismId'],
        loading: 0,
        queryKey: '',
        appType: '',
        appTypes: [],
        tableData: [],
        multipleSelection: [],
        total: 0,
        page: 1,
        dialogTopMgVisible: 0,
        dialogConfig: {tip: '', data: '', type: ''}
      }
    },
    components: {},
    computed: {
      
      index () {
        var page = this.$getWPage('videoListPage')
        page = page ? page : 1
        return page
      }
    },
    methods: {
      submitVideo (row) {
        this.$showConfirm(this.$t('app_tip'), this.$t('app_tipVerify'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
          this.loading = 1
          this.$submitVideo(row.videoid, (res) => {
            this.loading = 0
            if (res.status === 200) {
              this.$message.success(res.message)
              this.getList()
            } else {
              this.$message.error(res.message)
            }
          }, (error) => {
            this.loading = 0
          }) 
        }, '')
      },
      editVideo (row) {
        this.$setWObj('editVideo', {type: 1, data: row})
        this.$router.push({path: 'video-list/edit-video'})
      },
      deleteVideo (row) {
        //console.log(row)
        this.$showConfirm(this.$t('app_tip'), this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
          this.loading = 1
          this.$delVideo(row.videoid, (res) => {
            this.loading = 0
            if (res.status === 200) {
              this.$message.success(res.message)
              this.getList()
            } else {
              this.$message.error(res.message)
            }
          }, (error) => {
            this.loading = 0
          }) 
        }, '')
        
      },
      getStatus (value) {
        if (!value) return ''
        switch (value.status) {
          case 0:
            return {vl: this.$t('app_prePushVerify'), style: 'color:#8492A6;'}
          case 1:
            return {vl: this.$t('app_preVerify'), style: 'color:#F7BA2A;'}
          case 2:
            return {vl: this.$t('app_verifyPass'), style: 'color:#13CE66;'}
          case 3:
            return {vl: this.$t('app_verifyNotPass'), style: 'color:#FF4949;'}
        }
      },
      timeLimit (row) {
        return mm(row.sTime).format('YYYY-MM-DD') + ' ~ ' + mm(row.eTime).format('YYYY-MM-DD')
      },
      setInstallType (type) {
        return this.$installType[type]
      },
      query () {
        this.getList()
      },
      reset () {
        this.queryKey = ''
        this.appType = ''
        this.getList()
      },
      selectChange (vl) {
        this.getList()
      },
      getTypeList () {
        this.$getAppTypeList(100000000, 1, (res) => {
          if (res.status === 200) {
            // console.log(res)
            this.appTypes = res.data
          } else {
            this.$message(res.message)
          }
        }, '')
      },
      cellClick (row, ev, col) {
        if (col.label && col.label !== this.$t('app_operate') && col.label !== this.$t('app_classIntrol') && col.label !== this.$t('app_homeIntrol')) {
          /*switch (row.status) {
            case 0:
            case 3:
              this.$setWObj('editVideo', {type: 1, data: row})
              this.$router.push({path: 'video-list/edit-video'})
              break
            case 1:
            case 2:
              this.$setWObj('viewVideo', row)
              this.$router.push({path: '/video-list/detail'})
              break
          }*/
          // console.log(row)
          /*this.$setWObj('editAppConfig', {type: 2, data: row})
          this.$router.push({path: '')})*/
          this.$setWObj('viewDefaultVideo', row)
          this.$router.push({path: '/video-list/default/view-video'})
        }
      },
      dateFormat (row, column) {
        var date = row[column.property]
        if (date === undefined) {
          return ''
        }
        return mm(date).format('YYYY-MM-DD HH:mm:ss')
      },
      pageSelect (index) {
        this.$setWPage('videoListPage', index)
        this.getList()
      },
      pageSized (val) {
        this.$gRow = val
        this.getList()
      },
      toggleSelection (rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row)
          })
        } else {
          this.$refs.multipleTable.clearSelection()
        }
      },
      processRecommend (yes) {
        this.dialogTopMgVisible = 0
        var config = this.dialogConfig
        switch(config.type) {
          case 'class':
            this.loading = 1
            var typeId = config.data.appCategoryId
            // var vl = yes ? typeId : ''
            var vl = yes ? '0' : '1'
            if (this.$appUrlTag === 0) {
              this.$recommendClass(this.mechanismId, config.data.applicationid, vl, (res) => {
                this.loading = 0
                if (res.status === 200) {
                  var tm = config.data
                  tm.isType = vl
                  this.tableData[config.index] = tm
                } else {
                  this.$message.error(res.message)
                }
              }, () => {
                this.loading = 0
              })
            } else {
              this.$recommendClass1(this.mechanismId, config.data.applicationid, vl, (res) => {
                this.loading = 0
                if (res.status === 200) {
                  var tm = config.data
                  tm.isType = vl
                  this.tableData[config.index] = tm
                } else {
                  this.$message.error(res.message)
                }
              }, () => {
                this.loading = 0
              })
            }
            
            break
          case 'home':
            this.loading = 1
            // var vl = yes ? '1' : '0'
            var vl = yes ? '0' : '1'
            if (this.$appUrlTag === 0) {
              this.$recommendHome(this.mechanismId, config.data.applicationid, vl, (res) => {
                this.loading = 0
                if (res.status !== 200) {
                  this.$message.error(res.message)
                } else {
                  var tm = config.data
                  tm.isHome = vl
                  this.tableData[config.index] = tm
                }
              }, () => {
                this.loading = 0
              })
            } else {
              this.$recommendHome1(this.mechanismId, config.data.applicationid, vl, (res) => {
                this.loading = 0
                if (res.status !== 200) {
                  this.$message.error(res.message)
                } else {
                  var tm = config.data
                  tm.isHome = vl
                  this.tableData[config.index] = tm
                }
              }, () => {
                this.loading = 0
              })
            }
            
            break
        }
      },
      classRecommend (row, scope) {
        this.dialogTopMgVisible = 1
        this.dialogConfig = {type: 'class', data: row, tip: this.$t('app_isIntroClass'), index: scope.$index}
      },
      homeRecommend (row, scope) {
        this.dialogTopMgVisible = 1
        this.dialogConfig = {type: 'home', data: row, tip: this.$t('app_isIntroHome'), index: scope.$index}
      },
      undercarriage (row) {
        
        // console.log(row)
        this.$showConfirm(this.$t('app_tip'), this.$t('app_isOffShelf'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
          this.loading = 1
          if (this.$appUrlTag === 0) {
            this.$appDistributeOnOff(this.mechanismId, row.packagename, '1', (res) => {
              if (res.status === 200) {
                // this.$message.success(res.message)
                this.getList()
              } else {
                this.$message.error(res.message)
              }
              this.loading = 0
            }, () => {
              // error
              this.loading = 0
            })
          } else {
            this.$appDistributeOnOff1(this.mechanismId, row.packagename, '1', (res) => {
              if (res.status === 200) {
                // this.$message.success(res.message)
                this.getList()
              } else {
                this.$message.error(res.message)
              }
              this.loading = 0
            }, () => {
              // error
              this.loading = 0
            })
          }
          
        }, '')
        
      },
      allUndercarriage () {
        this.$showConfirm(this.$t('app_tip'), this.$t('app_srmuldel'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
          var ids = ''
          this.multipleSelection.forEach((vl) => {
            ids += vl.videoid + ','
          })
          ids = ids.substring(0, ids.length - 1)
          
          if (!ids) {
            this.$message(this.$t('app_chooseOneMust'))
            return
          }
          this.loading = 1
          this.$delVideo(ids, (res) => {
            this.loading = 0
            if (res.status === 200) {
              this.$message.success(res.message)
              this.getList()
            } else {
              this.$message.error(res.message)
            }
          }, (error) => {
            this.loading = 0
          }) 
          
        }, '')

      },
      handleSelectionChange (val) {
        this.sNum = val.length
        this.multipleSelection = val
      },
      addVideo () {
        //this.$setWObj('editVideo', {type: 0, data: ''})
        this.$router.push({path: '/video-list/default/add-video'})
      },
      bindOperate (obj) {
        //console.log(obj)
        //return
        this.$setWObj('appBindInfo', {data: obj, type: 1})
        // /default/view-video
        //this.$router.push({name: this.$t('menu.appManageSub.customPush')})
        this.$router.push({path: '/default/view-video'})
      },
      selected (rows) {
        /* rows.forEach(row => {
          console.log('e', row)
          this.$refs.multipleTable.toggleRowSelection(row);
        }) */
      },
      getList () {
        this.loading = 1
        var sName = this.queryKey ? this.queryKey : ''
        var sCid = this.appType ? this.appType : ''
    
        this.$defaultVideoList(window.localStorage['mechanismId'], this.index, this.$gRow, sName, (res) => {
          console.log(res)
          this.loading = 0
          if (res.status === 200) {
            this.total = res.total
            this.tableData = res.data
            // console.log('tbd', res.data)
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          this.loading = 0
          // error
        })
        
        
      }
    },
    mounted () {
      //this.getTypeList()
      this.getList()
    }
  }
</script>



// WEBPACK FOOTER //
// defaultList.vue?6a6ea01a